import { Theme as ThemeMui5 } from '@mui/material/styles/createTheme';
import { SxProps } from '@mui/system';

export const labelInputStyles: SxProps<ThemeMui5> = () => ({
  '&.MuiInputLabel-root ': {
    pointerEvents: 'auto',
  },
});

export const popoverStyles: SxProps<ThemeMui5> = (theme) => ({
  position: 'relative',
  top: theme.spacing(0.2),
});

export const accordionHeaderStyles: SxProps<ThemeMui5> = () => ({
  padding: 0,
  '& .MuiAccordionSummary-content': {
    justifyContent: 'start',
  },
});
